<template>
	<v-dialog
		v-model="showModal"
		content-class="voucher-product-selection-dialog dialog-over-whole-page"
		persistent
	>
		<div class="voucher-product-selection-dialog-wrapper">
			<div class="close-btn-voucher">
				<v-icon class="close-btn-voucher-body" @click.prevent="closeDialog()">close</v-icon>
			</div>
			<div class="voucher-product-selection-dialog-body">
				<div class="voucher-product-selection-dialog-title">
					{{ $t("utilityComponents.voucherProductSelection.title") }}
				</div>
				<div class="products-container">
					<v-flex v-for="product in products" :key="product.id" class="voucher-product-item">
						<div @click.self="changeSelection(product.id)" class="sub-product-wrapper">
							<div class="product-image ">
								<VImg
									:src="backImg(product)"
								/>
							</div>
							<div class="subproduct-name-price">
								<div class="subproduct-name" :class="{'checked-text' : product.id === chosenProductId}">
									{{ product.name | translate(`product.${product.id}.name`) }}
								</div>
							</div>
							<div class="price-checkbox-wrapper">
								<div class="subproduct-price">
									<div class="product-price">{{ formatPriceZero(getDiscountedProductPrice(product)) }}</div>
									<div class="product-price-before">{{ formatPriceZero(product.price) }}</div>
								</div>
								<v-checkbox class="subproduct-checkbox"
								            :key="product.id"
								            :value="product.id"
								            v-model="chosenProductId"
								            hide-details
								            @click.stop="changeSelection(product.id)"
								/>
							</div>
						</div>
						<div class="divider"></div>
					</v-flex>
				</div>
				<v-flex row class="voucher-product-dialog-actions-part">
					<v-btn class="transparent-btn btn-transparent" @click.prevent="closeDialog()">
						{{ $t("utilityComponents.voucherProductSelection.rejectButton") }}
					</v-btn>
					<v-btn :disabled="!chosenProductId" class="green-btn btn-secondary" @click="onConfirmSelection">
						{{ $t("utilityComponents.voucherProductSelection.confirmButton") }}
					</v-btn>
				</v-flex>
			</div>
		</div>
	</v-dialog>
</template>

<script>
import appConfig, {channelEnum} from "../../appconfig";
import {formatPriceZero} from "../../domains2/libraries/Utils";
import {getBackImages} from "../../libraries/utils";
import {getProductSpecificDiscount} from "../../domains2/priceRules/priceRulesHelpers";

export default {
	name: "VoucherProductSelection",
	props: ["products", "showModal", "applicableDiscount"],
	data() {
		return {
			transitionClasses: "modal-big group-grid-dialog",
			chosenProductId: null
		};
	},
	methods: {
		formatPriceZero,
		onConfirmSelection() {
			this.$emit("productSelected", this.chosenProductId);
		},
		closeDialog() {
			this.$emit("closeVoucherProductSelectionModal", false, false);
		},
		changeSelection(productId) {
			this.chosenProductId = productId;
		},
		backImg(product) {
			const backImages = getBackImages(product, this.isKioskChannel, false, true);
			if(backImages && backImages.length > 0) {
				return backImages[0];
			}
			return "";
		},
		getDiscountedProductPrice(product) {
			if(!this.applicableDiscount) {
				return product.price;
			}
			const price = product.price - getProductSpecificDiscount({
				price: product.price,
				discount: this.applicableDiscount
			});
			return price > 0 ? price : 0;
		}
	},
	computed: {
		isKioskChannel() {
			return appConfig.channelAlias() === channelEnum.kiosk;
		},
		isBM100() {
			return appConfig.isBM100();
		}
	}
};
</script>

<style scoped lang="scss">

/deep/ .voucher-product-selection-dialog {
	background-color: #000000;
	width: 100%;
	margin: 0;
	height: 100vh;
	max-height: 100vh;
	.voucher-product-selection-dialog-wrapper {
		color: #FFFFFF;
		padding: 16px;
		.voucher-product-selection-dialog-title {
			text-align: center;
			font-weight: 700;
			font-size: 18px;
			line-height: 18px;
			text-transform: uppercase;
		}
		.products-container {
			height: calc(100vh - 265px);
			overflow: auto;
			margin: 30px 0 20px;
			.voucher-product-item {
				display: flex;
				flex-direction: column;
				.product-image {
					width: 100px;
					height: 100px;
					.v-image__image {
						width: 100px;
						height: 100px;
					}
					.v-responsive__sizer {
						height: auto;
					}
				}
				.sub-product-wrapper {
					display: flex;
					width: 100%;
					gap: 12px;
					.subproduct-name-price {
						display: flex;
						flex-grow: 1;
						.subproduct-name {
							font-size: 14px;
							line-height: 1;
							font-weight: 700;
							text-transform: uppercase;
						}
					}
					.subproduct-price {
						font-size: 14px;
						.product-price {
							font-weight: 700;
						}
						.product-price-before {
							font-weight: 400;
							text-decoration: line-through;
						}
					}
				}
				.divider {
					width: 100%;
					background-color: #202020;
					height: 2px;
					margin: 16px 0;
				}
				.v-input--checkbox {
					border-radius: 3px;
					background-color: transparent;
					flex: 0 1 auto;
					&.v-input--is-label-active {
						background-color: transparent;
						border: none;
					}
					.v-input__slot {
						background-color: transparent;
					}
					.v-input__slot .v-input--selection-controls__ripple {
						width: 34px;
						height: 34px;
						border-radius: 3px;
						background-color: #202020;
						border: 2px solid #26282c;
						.v-icon {
							color: transparent !important;
						}
						&.accent--text {
							content: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxOSIgdmlld0JveD0iMCAwIDIwIDE5Ij4KICAgIDxwYXRoIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEuNzIyIDEwLjkxNGw0Ljk1IDQuOTVMMTcuMjc4IDUuMjU3bDEuNDE0IDEuNDE1LTEyLjAyIDEyLjAyLTYuMzY0LTYuMzY0IDEuNDE0LTEuNDE0eiIvPgo8L3N2Zz4K);
							height: 34px;
							width: 34px;
							padding-bottom: 9px;
							padding-top: 5px;
							background-color: #ffd800;
							border-radius: 3px;
							border: none;
						}
					}
				}
				.price-checkbox-wrapper {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					align-items: flex-end;
				}
			}
		}
	}
	.voucher-product-dialog-actions-part {
		display: flex;
		flex-direction: column;
		gap: 16px;
		.green-btn.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
			background-color: #218C74 !important;
			opacity: 0.5;
		}
	}
	.close-btn-voucher {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 10px;
		.close-btn-voucher-body {
			color: #FFFFFF;
			font-size: 30px;
		}
	}
}
</style>
